import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import {
  CustomInput,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import Select from 'react-select'

import { status } from '../../constants'

const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

class StandardPriceForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
    this.toggle = this.toggle.bind(this)
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => { this.toggle('1') } }
            >
              Standard Price Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ _.get(this.props, 'confirm') === 'standardPriceForm' ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Form>
                  <FormGroup>
                    <ContainerInTab>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Start Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            type="date"
                            name="start_date"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            value={ _.get(this.props, 'start_date') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      { _.get(this.props, 'create') === undefined &&
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Pay Grade ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="level_code"
                            disabled={ _.get(this.props, 'edit') || _.get(this.props, 'create') === undefined }
                            value={ _.get(this.props, 'level_code') }
                          />
                        </Col>
                      </Row>
                      }
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Pay Grade Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          { _.get(this.props, 'create') !== undefined &&
                          <SelectInputField
                            styles={ customStyles }
                            name='level_code'
                            isDisabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            value={ this.props.employee_level_id }
                            options={ this.props.lobs }
                            onChange={ this.props.handleLevel }
                          />
                          }
                          { _.get(this.props, 'create') === undefined &&
                          <InputField
                            name="level_name"
                            disabled={ _.get(this.props, 'edit') || _.get(this.props, 'create') === undefined }
                            value={ _.get(this.props, 'level_name') }
                            onChange={ this.props.handleInput }
                          />
                          }
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Cost</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <NumberField
                            name="cost"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Cost"
                            value={ _.get(this.props, 'cost') }
                            allowEmptyFormatting={ true }
                            thousandSeparator={ true }
                            decimalScale={ 2 }
                            fixedDecimalScale={ true }
                            onChange={ (e) => {
                              e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                              this.props.handleInput(e)
                            }
                            }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Price</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <NumberField
                            name="price"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Price"
                            value={ _.get(this.props, 'price') }
                            allowEmptyFormatting={ true }
                            thousandSeparator={ true }
                            decimalScale={ 2 }
                            fixedDecimalScale={ true }
                            onChange={ (e) => {
                              e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                              this.props.handleInput(e)
                            }
                            }
                          />
                        </Col>
                      </Row>
                      {
                        _.get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }><Label>Status</Label></Col>
                          <Col sm={ 9 }>
                            {
                              <CustomInputField
                                type="select"
                                id="is_active"
                                name="is_active"
                                disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                                value={ this.props.is_active }
                                onChange={ this.props.handleInput }
                              >
                                {
                                  status.map((s, key) => <option key={ key } value={ s.value }>{ s.label }</option>)
                                }
                              </CustomInputField>
                            }
                          </Col>
                        </Row>
                      }
                    </ContainerInTab>
                  </FormGroup>
                  <Right>
                    { _.get(this.props, 'button') }
                  </Right>
                </Form>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

StandardPriceForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}

export default StandardPriceForm

const NumberField = styled(NumberFormat)`
    font-family: 'Gotham' !important;
    text-align: right;
    width : 100%;
    heigth: 100%;
    font-size: 14px ;
    padding-right: 2%;
    border-radius: 5px;
    border: 1px solid #CCCCCC;
    background-color: ${props => {
    if (props.disabled) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`
const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const InputFieldDate = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    float: right;
    ::-webkit-inner-spin-button {
      display: none;
      -webkit-appearance: none;
    }
`
const ContainerInTab = styled(Container)`
    /* overflow-y: scroll;
    max-height: calc(100vh - 220px); */
`
const SelectInputField = styled(Select)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const Image = styled.img`
width: 20px;
height: 20px;
position: absolute;
right: 10px;
`
const CustomInputField = styled(CustomInput)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const customStyles = {
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? '#007bff' : "#FFFFFF",
    color: state.isFocused ? 'white' : 'black',
  }),
  menu: base => ({
    ...base,
    background: "#FFFFFF",
    padding: 0,
  }),
  control: base => ({
    ...base,
    background: "#FFFFFF",
  }),

}



// WEBPACK FOOTER //
// ./src/components/standard-price/index.js